import { FC } from 'react';

import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';

import { CTA_NAMES } from '@/utils/rudderstack';

import { TypeAccountERCPageTranslations } from '@/utils/translations/types/TypeAccountERCPageTranslations';

import { UpsellCard } from '../../_components/UpsellCard';

import { trackClickEvent } from '../utils';

export type LayoutNoSubscriptionProps = {
  t: TypeAccountERCPageTranslations;
  noSubscriptionCtaLink: string;
};

const LayoutNoSubscription: FC<LayoutNoSubscriptionProps> = ({
  t,
  noSubscriptionCtaLink,
}) => (
  <div data-testid="layout-no-subscription" className="text-center">
    <HeaderText
      classes="text-3xl md:text-4xl pb-2"
      size={HeaderSize.H2}
      align="left"
      text={t.noActiveSubscription}
    />

    <UpsellCard
      headerText={t.exploreTheEarlyReaderClub}
      subText={t.exploreTheEarlyReaderClubSubtext}
      ctaText={t.exploreTheEarlyReaderClub}
      ctaLink={noSubscriptionCtaLink}
      onClick={() => {
        trackClickEvent(CTA_NAMES.EXPLORE_THE_EARLY_READER_CLUB);
      }}
    />
  </div>
);

export default LayoutNoSubscription;
